import { render, staticRenderFns } from "./PoiMediaSlider.vue?vue&type=template&id=7f1f82f0&"
import script from "./PoiMediaSlider.vue?vue&type=script&lang=js&"
export * from "./PoiMediaSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PoiMediaSlider.vue"
export default component.exports